module.exports = __webpack_public_path__ + "img/Twitter.a90f0064.svg";